/**
 * SafetyEventsPage - Real-time safety event monitoring
 *
 * Surfaces the SafetyEventsDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visibility into safety events, incident tracking, and compliance monitoring.
 *
 * Route: /admin/safety-events
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons-react';

import { SafetyEventsDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function SafetyEventsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconShieldCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Safety Events</Title>
            <Text size="sm" c="dimmed">
              Real-time safety event monitoring, incident tracking, and compliance status
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SafetyEventsDashboard />
    </Container>
  );
}

export default SafetyEventsPage;
